import { QElement } from "./QElement";
import { QPoint } from "./QPoint";

// QDragBoxElement
export class QDragBoxElement extends QElement {
  constructor() {
    super();
    this.fStartDragX = 0;
    this.fStartDragY = 0;

    this.fOrigDragX = null;
    this.fOrigDragY = null;
  }

  InitDragBox(releaseCmd) {
    this.SetIsSelectable(false);
    //this.SetDraggable(true);
    this.SetIsControl(true);
    this.SetControlReleaseCmdCode(releaseCmd);
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();

    ctx.fillStyle = "#CAE5FF";
    ctx.strokeStyle = "#7EBFFF";
    ctx.linewidth = 2;

    ctx.strokeRect(this.fHorzOffset, this.fVertOffset, this.fWidth, this.fHeight);

    ctx.globalAlpha = 0.5;
    ctx.fillRect(this.fHorzOffset, this.fVertOffset, this.fWidth, this.fHeight);

    ctx.restore();
  }

  SetDragPosition(canvasX, canvasY) {
    this.fStartDragX = canvasX;
    this.fStartDragY = canvasY;

    if (this.fOrigDragX == null) {
      this.fOrigDragX = canvasX;
      this.fOrigDragY = canvasY;
    }
  }

  DeltaFromDragPosition(x, y, updateDragPosition) {
    var delta = new QPoint();
    delta.fX = x - this.fStartDragX;
    delta.fY = y - this.fStartDragY;

    if (updateDragPosition) this.SetDragPosition(x, y);

    return delta;
  }

  DeltaFromDragOrigin() {
    var delta = new QPoint();
    delta.fX = this.fStartDragX - this.fOrigDragX;
    delta.fY = this.fStartDragY - this.fOrigDragY;

    return delta;
  }
}
